export const getToken = () => {
  return localStorage.getItem('access_token') || sessionStorage.getItem('access_token') || null;
};

export const getTokenHeader = (token = getToken()) => {
  return { Authorization: `Bearer ${token}` };
};
